import baseMatches from "./component-library277.mjs";
import baseMatchesProperty from "./component-library278.mjs";
import identity from "./component-library279.mjs";
import isArray from "./component-library244.mjs";
import property from "./component-library280.mjs";
function baseIteratee(value) {
  if (typeof value == "function") {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == "object") {
    return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
  }
  return property(value);
}
export {
  baseIteratee as default
};
